module.exports = __webpack_public_path__ + "static/popup-ebffe18977c899d31a01964ff26f2598.png";